// extracted by mini-css-extract-plugin
export default {"list":"banner2_list__lW2Co","span_text":"banner2_span_text__NhIxc","text_color":"banner2_text_color__GUhOy","margins":"banner2_margins__-RYOY"};